import { render, staticRenderFns } from "./AssignedWithCaptain.vue?vue&type=template&id=518f8250&scoped=true"
import script from "./AssignedWithCaptain.vue?vue&type=script&lang=js"
export * from "./AssignedWithCaptain.vue?vue&type=script&lang=js"
import style0 from "./AssignedWithCaptain.vue?vue&type=style&index=0&id=518f8250&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518f8250",
  null
  
)

export default component.exports